import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { HeaderNav } from "../components/HeaderNav";
import { authApi, errDetail } from "../lib/api";
import { useLang } from "../lib/i18n";

const Shell = ({ children }) => (
  <div className="frz-page"><HeaderNav /><main className="frz-auth"><div className="frz-auth-card">{children}</div></main></div>
);

export function ForgotPassword() {
  const { t, te, lang } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await authApi.forgot(email, lang); setSent(true); } catch (err) { setError(te(errDetail(err))); } finally { setBusy(false); }
  };
  return (
    <Shell>
      <h1 className="frz-h2">{t("forgot_title")}</h1>
      {sent ? (
        <p className="frz-success" data-testid="forgot-confirmation">{t("forgot_sent")}</p>
      ) : (
        <form onSubmit={submit} className="frz-form" data-testid="forgot-form">
          <p className="frz-muted">{t("forgot_sub")}</p>
          <label className="frz-field"><span>{t("auth_email")}</span>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" /></label>
          {error && <p className="frz-error" data-testid="forgot-error">{error}</p>}
          <button type="submit" className="frz-btn frz-btn-primary frz-btn-block" disabled={busy} data-testid="forgot-submit-button">
            {busy && <Loader2 size={16} className="spin" />} {t("forgot_btn")}
          </button>
        </form>
      )}
      <Link to="/login" className="frz-link frz-small" data-testid="back-to-login-link">{t("back_login")}</Link>
    </Shell>
  );
}

export function ResetPassword() {
  const { t, te } = useLang();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) { setError(te("Le mot de passe doit contenir au moins 8 caractères")); return; }
    try { await authApi.reset(params.get("token") || "", password); setDone(true); setTimeout(() => nav("/login"), 1800); } catch (err) { setError(te(errDetail(err))); }
  };
  return (
    <Shell>
      <h1 className="frz-h2">{t("reset_title")}</h1>
      {done ? <p className="frz-success" data-testid="reset-success">{t("reset_done")}</p> : (
        <form onSubmit={submit} className="frz-form" data-testid="reset-form">
          <label className="frz-field"><span>{t("reset_new")}</span>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" data-testid="reset-password-input" /></label>
          {error && <p className="frz-error" data-testid="reset-error">{error}</p>}
          <button type="submit" className="frz-btn frz-btn-primary frz-btn-block" data-testid="reset-submit-button">{t("reset_btn")}</button>
        </form>
      )}
    </Shell>
  );
}
